import React from 'react';
import { ReactComponent as DownloadIcon } from '../../../assets/images/Download_Icon.svg';
import styles from './IconButtons.module.css';
import classNames from 'classnames';

const DownloadButton = ({
    text = null,
    id = 'download_secbtn',
    onClick,
    className = '',
    isDisabled = false,
    download = null
}) => {
    const downloadPDF = () => {
        const link = document.createElement('a');
        link.href = download;
        link.setAttribute('download', download.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button
            className={classNames('btn-secondary', styles.iconBtn, className)}
            id={id}
            onClick={() => (download ? downloadPDF() : onClick())}
            disabled={isDisabled}
        >
            <DownloadIcon
                alt='Download'
                id={id}
            />
            {text || 'Download'}
        </button>
    );
};

export default DownloadButton;
